import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { markWatched, removeFromWatchlist, processShifts } from "./watchlistActions";

const WatchListPage = () => {
  const dispatch = useDispatch();
  const items = useSelector((s) => s.watchlist.items);

  useEffect(() => {
    dispatch(processShifts());
  }, [dispatch]);

  const allItems = Object.values(items).sort(
    (a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate)
  );

  const today = new Date().toISOString().split("T")[0];

  const upcoming = allItems.filter(
    (i) => i.status === "planned" && i.scheduledDate >= today
  );
  const shifted = allItems.filter((i) => i.status === "shifted");
  const watched = allItems.filter((i) => i.status === "watched");
  const overdue = allItems.filter(
    (i) => i.status === "planned" && i.scheduledDate < today
  );

  const renderItem = (item) => {
    const poster =
      item.Poster && item.Poster !== "N/A"
        ? item.Poster
        : "https://via.placeholder.com/60x90";

    const statusClass =
      item.status === "watched"
        ? "status-watched"
        : item.status === "shifted"
        ? "status-shifted"
        : item.scheduledDate < today
        ? "status-overdue"
        : "status-planned";

    return (
      <div key={item.imdbID} className={`watchlist-item ${statusClass}`}>
        <img src={poster} alt="" className="watchlist-thumb" />
        <div className="watchlist-info">
          <Link to={`/movie/${item.imdbID}`} className="watchlist-title">
            {item.Title}
          </Link>
          <span className="watchlist-year">{item.Year}</span>
          <div className="watchlist-schedule">
            <i className="fas fa-calendar-day mr-1"></i>
            {item.scheduledDate} at {item.scheduledTime}
            {item.shiftCount > 0 && (
              <span className="badge badge-warning ml-2">
                Shifted {item.shiftCount}x
              </span>
            )}
          </div>
        </div>
        <div className="watchlist-actions">
          {item.status !== "watched" && (
            <button
              className="btn btn-sm btn-success"
              onClick={() => dispatch(markWatched(item.imdbID))}
              title="Mark as Watched"
            >
              <i className="fas fa-check"></i> Watched
            </button>
          )}
          {item.status === "watched" && (
            <span className="badge badge-success p-2">
              <i className="fas fa-check-circle mr-1"></i> Watched
            </span>
          )}
          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => dispatch(removeFromWatchlist(item.imdbID))}
            title="Remove"
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      </div>
    );
  };

  const totalCount = allItems.length;

  return (
    <div className="container mt-4 mb-5">
      <h2 className="mb-1">
        <i className="fas fa-calendar-alt text-info mr-2"></i>
        Watch List
      </h2>
      <p className="text-muted mb-4">{totalCount} movies planned</p>

      {totalCount === 0 ? (
        <div className="empty-state">
          <i className="fas fa-calendar-plus"></i>
          <h4>No movies planned</h4>
          <p>Search for a movie and click the calendar icon to plan when to watch it.</p>
        </div>
      ) : (
        <>
          {overdue.length > 0 && (
            <div className="watchlist-section">
              <h5 className="section-label text-danger">
                <i className="fas fa-exclamation-triangle mr-1"></i> Overdue
              </h5>
              {overdue.map(renderItem)}
            </div>
          )}

          {shifted.length > 0 && (
            <div className="watchlist-section">
              <h5 className="section-label text-warning">
                <i className="fas fa-redo mr-1"></i> Rescheduled
              </h5>
              {shifted.map(renderItem)}
            </div>
          )}

          {upcoming.length > 0 && (
            <div className="watchlist-section">
              <h5 className="section-label text-info">
                <i className="fas fa-clock mr-1"></i> Upcoming
              </h5>
              {upcoming.map(renderItem)}
            </div>
          )}

          {watched.length > 0 && (
            <div className="watchlist-section">
              <h5 className="section-label text-success">
                <i className="fas fa-check-circle mr-1"></i> Watched
              </h5>
              {watched.map(renderItem)}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WatchListPage;
